/**
 * Helpers de entorno — detección de a qué backend apunta esta instancia.
 *
 * Se usa para el badge "Stack local" del Header: si la app está conectada al
 * stack de Supabase en Docker (127.0.0.1/localhost:54321), lo que el usuario
 * (o la IA del chat) haga NO toca las cuentas del proyecto remoto. Verlo de
 * un vistazo evita el accidente inverso: creer que estás en local y estar en prod.
 */

/** URL del stack local (definida en supabase/config.toml → [api] port). */
const LOCAL_STACK_PATTERN = /^https?:\/\/(127\.0\.0\.1|localhost):54321\/?$/;

/**
 * true si REACT_APP_SUPABASE_URL apunta al stack local de Supabase.
 * Evalúa en el momento de la llamada (no en el import) para que los tests
 * puedan variar la variable.
 */
export function isLocalStack(): boolean {
  const url = process.env.REACT_APP_SUPABASE_URL || '';
  return LOCAL_STACK_PATTERN.test(url.trim().replace(/\/+$/, ''));
}
